import { Controller } from "@hotwired/stimulus"

// Fades in the [data-reveal] blocks when they enter the viewport.
// Disabled for visitors who prefer reduced motion.
//
// <body data-controller="reveal"> … <div data-reveal>…</div>
export default class extends Controller {
  connect() {
    const blocks = this.element.querySelectorAll("[data-reveal]")
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add("is-revealed")
        this.observer.unobserve(entry.target)
      })
    }, { rootMargin: "0px 0px -10% 0px" })

    blocks.forEach((block) => {
      block.classList.add("will-reveal")
      this.observer.observe(block)
    })
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
